import React from 'react';

const STORAGE_KEY = 'compito_client_sources';

function load() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : {hackerNews: false};
    } catch {
        return {hackerNews: false};
    }
}

function save(sources) {
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(sources));
    } catch {
        // ignore
    }
}

export function useClientSideSources() {
    const [sources, setSources] = React.useState(load);

    const toggleHackerNews = () => {
        setSources((prev) => {
            const next = {...prev, hackerNews: !prev.hackerNews};
            save(next);
            return next;
        });
    };

    const removeHackerNews = () => {
        setSources((prev) => {
            const next = {...prev, hackerNews: false};
            save(next);
            return next;
        });
    };

    return {
        hackerNewsEnabled: sources.hackerNews,
        toggleHackerNews,
        removeHackerNews,
    };
}
